import init from '@/lib/_init'

const envObj = {
  API_URL: process.env.API_URL || process.env.NEXT_PUBLIC_API_URL || '',
  APP_URL:
    process.env.APP_URL ||
    process.env.NEXT_PUBLIC_APP_URL ||
    'http://localhost:8081',
  PLATFORM_URL:
    process.env.PLATFORM_URL ||
    process.env.NEXT_PUBLIC_PLATFORM_URL ||
    'https://app.consentwow.com',

  GTM_CONTAINER_ID: '',
  COOKIE_BANNER_ID: '',

  IS_PROD: false,
}

init(envObj.API_URL)

export default { ...envObj }
